module.exports = __webpack_public_path__ + "static/media/mickey3_portuguese_4.c5da8174.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mickey3_portuguese_4.png
// module id = 160
// module chunks = 0